import React from "react"
import {
  ReactUseState,
  IsSearchingContext,
  GridInitializedContext,
  IsRestoreSearchingContext,
  IsPromptRefContext,
} from "../../../components/Context"
import {
  TKaikonZyutyuHaisyaTableReq,
  TKaikonZyutyuHaisyaListGetRes,
} from "../../../service/orderContainer/kaikonZyutyuHaisya/TKaikonZyutyuHaisya"

// TODO:API確定後、responseの型に変更
export const SearchResultContext = React.createContext<
  TKaikonZyutyuHaisyaListGetRes[] | undefined
>([])

export const SearchMethodContext = React.createContext<
  (searchCondition?: TKaikonZyutyuHaisyaTableReq) => unknown
>(() => {})

export const SearchConditionContext = React.createContext<
  TKaikonZyutyuHaisyaTableReq | undefined
>({} as TKaikonZyutyuHaisyaTableReq)

export const searchDyFromContext = React.createContext<
  ReactUseState<string | null | undefined>
>({} as ReactUseState<string | null | undefined>)

export const searchDyToContext = React.createContext<
  ReactUseState<string | null | undefined>
>({} as ReactUseState<string | null | undefined>)

export const searchBusyoCdContext = React.createContext<
  ReactUseState<string | null>
>({} as ReactUseState<string | null>)

export const searchUnkoBusyoCdContext = React.createContext<
  ReactUseState<string | null>
>({} as ReactUseState<string | null>)

export const ZyutyubusyoContext = React.createContext<string>("")

/**
 * 海コン受注配車入力のProvider
 */
export const KaikonZyutyuHaisyaTableProvider: React.FC<{
  isSearching: ReactUseState<boolean>
  isRestoreSearching: ReactUseState<boolean>
  gridInitialized: ReactUseState<boolean>
  SearchResult: Array<TKaikonZyutyuHaisyaListGetRes> | undefined
  searchCondition: TKaikonZyutyuHaisyaTableReq | undefined
  search: (searchCondition?: TKaikonZyutyuHaisyaTableReq) => unknown
  受注部所コード: string
  searchDyFrom: ReactUseState<string | null | undefined>
  searchDyTo: ReactUseState<string | null | undefined>
  searchBusyoCd: ReactUseState<string | null>
  searchUnkoBusyoCd: ReactUseState<string | null>
  isPrompt: React.MutableRefObject<boolean>
}> = (props) => {
  return (
    <IsSearchingContext.Provider value={props.isSearching}>
      <SearchResultContext.Provider value={props.SearchResult}>
        <GridInitializedContext.Provider value={props.gridInitialized}>
          <IsRestoreSearchingContext.Provider value={props.isRestoreSearching}>
            <SearchConditionContext.Provider value={props.searchCondition}>
              <SearchMethodContext.Provider value={props.search}>
                <ZyutyubusyoContext.Provider value={props.受注部所コード}>
                  <searchDyFromContext.Provider value={props.searchDyFrom}>
                    <searchDyToContext.Provider value={props.searchDyTo}>
                      <searchUnkoBusyoCdContext.Provider
                        value={props.searchUnkoBusyoCd}>
                        <searchBusyoCdContext.Provider
                          value={props.searchBusyoCd}>
                          <IsPromptRefContext.Provider value={props.isPrompt}>
                            {props.children}
                          </IsPromptRefContext.Provider>
                        </searchBusyoCdContext.Provider>
                      </searchUnkoBusyoCdContext.Provider>
                    </searchDyToContext.Provider>
                  </searchDyFromContext.Provider>
                </ZyutyubusyoContext.Provider>
              </SearchMethodContext.Provider>
            </SearchConditionContext.Provider>
          </IsRestoreSearchingContext.Provider>
        </GridInitializedContext.Provider>
      </SearchResultContext.Provider>
    </IsSearchingContext.Provider>
  )
}
